import { createRoot } from 'react-dom/client';
import App from './App';
import { OverlayContext, defaultOverlayContext } from './components';
import styles from './app.less';

/**
 * Custom web component wrapper.
 */
import { jsx as _jsx } from "react/jsx-runtime";
class ImaErrorOverlay extends HTMLElement {
  connectedCallback() {
    this.attachShadow({
      mode: 'open'
    });

    // Create app root element
    const container = document.createElement('div');
    container.setAttribute('data-ima-error-overlay', '');
    const root = createRoot(container);

    // Append styles and root
    styles.use({
      target: this.shadowRoot
    });
    this.shadowRoot?.appendChild(container);

    // Get component attributes
    const publicUrl = this.getAttribute('public-url');
    const serverError = this.getAttribute('server-error');

    // Render App
    root.render(/*#__PURE__*/_jsx(OverlayContext.Provider, {
      value: {
        publicUrl: publicUrl ?? defaultOverlayContext.publicUrl
      },
      children: /*#__PURE__*/_jsx(App, {
        serverError: serverError
      })
    }));
  }
}
customElements.define('ima-error-overlay', ImaErrorOverlay);